import { render, staticRenderFns } from "./PrescriptionOZP.vue?vue&type=template&id=10fd7b24&scoped=true&"
import script from "./PrescriptionOZP.vue?vue&type=script&lang=js&"
export * from "./PrescriptionOZP.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionOZP.vue?vue&type=style&index=0&id=10fd7b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd7b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VSimpleCheckbox})
